export default __webpack_public_path__ + "static/media/Vacaspan.7b625433.jpeg";